export default __webpack_public_path__ + "./images/ss.ac20f86e.png";